import Button from "components/button/Button";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import { ERROR_MSG } from "constants/Constants";
import { useFormik } from "formik";
import {
  apiGetThresholdSetting,
  apiUpdateThresholdSetting,
} from "helpers/api/setting-threshold";
import { isNil, keys, some } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { showToastError, showToastSuccess } from "utils";
import * as yup from "yup";

const SettingThreshold = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(0);

  const { values, errors, handleChange, validateForm, setFieldValue } =
    useFormik({
      validateOnChange: false,
      initialValues: {
        variousThreshold: undefined,
        sensorThreshold: undefined,
        monitorAndNotification: undefined,
      },
      validationSchema: yup.object().shape({
        variousThreshold: yup
          .number()
          .required(ERROR_MSG.REQUIRE)
          .min(1, t("messages.MSG-USP098", { from: 1, to: 14999 }))
          .max(14999, t("messages.MSG-USP098", { from: 1, to: 14999 })),
        sensorThreshold: yup
          .number()
          .required(ERROR_MSG.REQUIRE)
          .min(1, t("messages.MSG-USP082", { from: 1, to: 200 }))
          .max(200, t("messages.MSG-USP082", { from: 1, to: 200 })),
        monitorAndNotification: yup
          .number()
          .required(ERROR_MSG.REQUIRE)
          .min(1, t("messages.MSG-USP099")),
      }),
    });

  const getThresholdSetting = () => {
    setLoading((prev) => prev + 1);
    apiGetThresholdSetting()
      .then(({ error, data }) => {
        if (error) {
          showToastError(error.message);
        }
        if (data) {
          setFieldValue("variousThreshold", data.battery_threshold);
          setFieldValue("sensorThreshold", data.adc_threshold);
          setFieldValue("monitorAndNotification", data.disconnect_threshold);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  useEffect(() => {
    getThresholdSetting();
  }, []);

  const handleSave = async () => {
    const isValid = Boolean(!keys(await validateForm()).length);
    if (isValid) {
      setLoading((prev) => prev + 1);
      apiUpdateThresholdSetting({
        battery_threshold: values.variousThreshold,
        adc_threshold: values.sensorThreshold,
        disconnect_threshold: values.monitorAndNotification,
      })
        .then((res) => {
          if (res.error) {
            showToastError(res.error.message);
          } else {
            showToastSuccess("messages.MSG-USP081");
          }
        })
        .catch(({ error }) => {
          showToastError(`messages.${error.reason}`);
        })
        .finally(() => {
          setLoading((prev) => prev - 1);
        });
    }
  };

  return (
    <div className="notice-container main-content">
      <div className="root-right-header">
        <div className="screen-name">{t("admin_role")}</div>
      </div>
      <form
        style={{
          padding: 20,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "100%",
            fontSize: 30,
            fontWeight: "bold",
            marginBottom: 50,
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          {t("settingThreshold.title")}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "40px",
          }}
        >
          <div>
            <div style={{ fontSize: 16, marginBottom: "10px" }}>
              {t("settingThreshold.various_threshold")}
            </div>
            <div
              style={{
                width: window.innerWidth < 768 ? "100%" : 500,
              }}
            >
              <InputComponent
                width="100%"
                type="number"
                name="variousThreshold"
                value={values?.variousThreshold}
                error={errors?.variousThreshold}
                onChange={handleChange}
              />
            </div>
          </div>
          <div>
            <div style={{ fontSize: 16, marginBottom: "10px" }}>
              {t("settingThreshold.sensor_threshold")}
            </div>
             <div
              style={{
                width: window.innerWidth < 768 ? "100%" : 500,
              }}
            >
              <InputComponent
                width="100%"
              type="number"
              name="sensorThreshold"
              value={values?.sensorThreshold}
              error={errors?.sensorThreshold}
              onChange={handleChange}
            />
            </div>
          </div>
          <div>
            <div style={{ fontSize: 16, marginBottom: "10px" }}>
              {t("settingThreshold.monitor_and_notification")}
            </div>
            <div
              style={{
                width: window.innerWidth < 768 ? "100%" : 500,
              }}
            >
              <InputComponent
                width="100%"
              type="number"
              name="monitorAndNotification"
              value={values?.monitorAndNotification}
              error={errors?.monitorAndNotification}
              onChange={handleChange}
            />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            text={t("settingThreshold.save")}
            type="button"
            height={40}
            width={300}
            disabled={some(Object.values(values), (item) => isNil(item))}
            onClick={() => handleSave()}
            style={{
              fontSize: 20,
              fontWeight: "bold",
              borderRadius: 60,
              margin: "50px 0 0 0",
            }}
          />
        </div>
      </form>
      {loading ? <Loading /> : null}
    </div>
  );
};

export default SettingThreshold;
